import React from "react";
import { altColor, secondaryTextColorOppositeShade } from "../../utils/constants";

export default function LikedTPInfoIcon({ color = altColor, color2 = secondaryTextColorOppositeShade }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.98 21.98">
      <defs>
        <radialGradient id="Unbenannter_Verlauf_195" cx="10.99" cy="10.99" r="10.49" gradientUnits="userSpaceOnUse">
          <stop offset="0" stop-color={color} />
          <stop offset="1" stop-color={color} />
        </radialGradient>
      </defs>
      <g id="Ebene_2" data-name="Ebene 2">
        <g id="Ebene_1-2" data-name="Ebene 1">
          <circle
            stroke={color}
            fill="url(#Unbenannter_Verlauf_195)"
            strokeMiterlimit="10"
            cx="10.99"
            cy="10.99"
            r="10.49"
          />
          <g id="Ebene_2-2" data-name="Ebene 2">
            <g id="Ebene_1-2-2" data-name="Ebene 1-2">
              <path
                fill="none"
                stroke={color2}
                strokeWidth="0.5px"
                strokeMiterlimit="10"
                d="M6.93,11.51H6.41a.72.72,0,1,1,0-1.43H8.74a18.55,18.55,0,0,1-.36-2.45,2.73,2.73,0,0,1,.15-1.34c.19-.39.66-.63,1-.37s.3.73.36,1.15a6.22,6.22,0,0,0,.9,2.19l.5.88.76.14"
              />
              <path
                fill="none"
                stroke={color2}
                strokeWidth="0.5px"
                strokeMiterlimit="10"
                d="M6.92,11.64H5.86a.72.72,0,0,0-.67.76.73.73,0,0,0,.67.68H7.05"
              />
              <path
                fill="none"
                stroke={color2}
                strokeWidth="0.5px"
                strokeMiterlimit="10"
                d="M7.05,13H6.46a.72.72,0,0,0-.68.75.72.72,0,0,0,.68.68h.72"
              />
              <path
                fill="none"
                stroke={color2}
                strokeWidth="0.5px"
                strokeMiterlimit="10"
                d="M7.18,14.38H6.93a.67.67,0,0,0-.68.6.65.65,0,0,0,.61.69h.52l3.07.13h.09l.86-.39"
              />
              <rect
                stroke={color2}
                fill={color2}
                strokeWidth="0.25px"
                strokeMiterlimit="10"
                x="12"
                y="10.21"
                width="2.34"
                height="5.6"
                rx="0.85"
              />
              <path
                stroke={color2}
                fill={color2}
                strokeWidth="0.25px"
                strokeMiterlimit="10"
                d="M16.26,15.42H15s-.1,0-.1-.07h0c0-.06.05-.1.1-.19h1.25c.06.09.1.13.1.19h0C16.36,15.4,16.32,15.45,16.26,15.42Z"
              />
              <circle
                stroke={color2}
                fill={color2}
                strokeWidth="0.25px"
                strokeMiterlimit="10"
                cx="16.88"
                cy="15.35"
                r="0.1"
              />
              <path
                stroke={color2}
                fill={color2}
                strokeWidth="0.25px"
                strokeMiterlimit="10"
                d="M16.42,10.86H15.17c-.06-.08-.1-.13-.1-.18h0a.08.08,0,0,1,.07-.08h1.28a.07.07,0,0,1,.09.05,0,0,0,0,1,0,0h0C16.52,10.74,16.47,10.78,16.42,10.86Z"
              />
              <circle
                stroke={color2}
                fill={color2}
                strokeWidth="0.25px"
                strokeMiterlimit="10"
                cx="17.04"
                cy="10.68"
                r="0.1"
              />
              <path
                stroke={color2}
                fill={color2}
                strokeWidth="0.25px"
                strokeMiterlimit="10"
                d="M17.06,12.42H16c-.06-.05-.1-.09-.1-.15h0a.12.12,0,0,1,.1-.11h1.07a.14.14,0,0,1,.1.11h0C17.16,12.33,17.11,12.37,17.06,12.42Z"
              />
              <circle
                stroke={color2}
                fill={color2}
                strokeWidth="0.25px"
                strokeMiterlimit="10"
                cx="17.66"
                cy="12.27"
                r="0.1"
              />
              <path
                stroke={color2}
                fill={color2}
                strokeWidth="0.25px"
                strokeMiterlimit="10"
                d="M16,14h-.86c-.06-.08-.1-.12-.1-.18h0a.09.09,0,0,1,.08-.09H16a.08.08,0,0,1,.09.06v0h0C16.12,13.87,16.08,13.91,16,14Z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
